import { i18n } from '@/locales';
import enumSurchargeType from '@/constants/surchargeType';
import { delayReasonType, operationSettingType, } from '@/constants/operationSetting/option';
import { objDeepCopy } from '@/utils/object';
const lc = 'views.operation_setting_dialog.';
export const tabList = [
    {
        key: 1,
        componentName: 'ApplyConfigSurcharge',
        text: i18n.t(`${lc}apply_config_surcharge`),
        value: operationSettingType.APPLY_IRREGULAR_SURCHARGE,
    },
    {
        key: 2,
        componentName: 'IrregularSurcharge',
        text: i18n.t(`${lc}irregular_surcharge`),
        value: operationSettingType.IRREGULAR_SURCHARGE,
    },
    {
        key: 3,
        componentName: 'DeliveryStatus',
        text: i18n.t(`${lc}delivery_status`),
        value: operationSettingType.DELIVERY_STATUS,
    },
];
const surchargeReason = objDeepCopy(enumSurchargeType);
Reflect.deleteProperty(surchargeReason, surchargeReason.NONE.value);
export const surchargeReasonOptionList = Object.values(surchargeReason);
// 5분부터 60분까지 12개
const emptyArray = new Array(12).fill(null);
const timeGap = 5;
const delayTimeType = emptyArray.map((_, index) => ({
    value: timeGap * (index + 1),
    text: i18n.t('common.minutes_suffix', {
        minutes: timeGap * (index + 1),
    }),
}));
export const delayTimeTypeOptionList = delayTimeType;
const delayAndStopReasonType = {
    BAD_WEATHER: {
        value: delayReasonType.BAD_WEATHER,
        text: i18n.t(`${lc}delay_reason_type.bad_weather`),
    },
    OVER_CAPACITY: {
        value: delayReasonType.OVER_CAPACITY,
        text: i18n.t(`${lc}delay_reason_type.over_capacity`),
    },
    RIDER_ACCIDENT: {
        value: delayReasonType.RIDER_ACCIDENT,
        text: i18n.t(`${lc}delay_reason_type.rider_accident`),
    },
    ETC: {
        value: delayReasonType.ETC,
        text: i18n.t(`${lc}delay_reason_type.etc`),
    },
};
export const delayResonOptionList = Object.values(delayAndStopReasonType);
export const stopResonOptionList = Object.values(delayAndStopReasonType);
